import { SesamiDayObject } from '@/@types/calendar';
import { cn } from '@/entrypoints/utils';
import { format } from 'date-fns';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';
import { selectedDayAtom } from './calendar-atoms';

type Props = {
  day: SesamiDayObject;
};

function CalendarDay({ day }: Props) {
  const [hasTimeslots, setHasTimeslots] = useState(false);

  const setSelectedDay = useSetAtom(selectedDayAtom);

  useEffect(() => {
    day.getAvailabilities().then((availabilities) => {
      setHasTimeslots(availabilities.length > 0);
    });
  }, [day]);

  const handleDayClick = useCallback(() => {
    if (!hasTimeslots) {
      return;
    }
    setSelectedDay(day.date);
  }, [day.date, hasTimeslots, setSelectedDay]);

  return (
    <div
      className={cn(
        'medispa-calendar_day',
        day.isCurrentMonth ? '' : 'is-outside-month',
        hasTimeslots ? '' : 'no-timeslots',
      )}
      onClick={handleDayClick}
    >
      <h6 className="medispa-calendar_day-title">{format(day.date, 'dd')}</h6>
      <div
        className="medispa-calendar_availabilities-dot"
        style={{ backgroundColor: !hasTimeslots ? 'transparent' : '' }}
      ></div>
    </div>
  );
}

export default CalendarDay;
